import { Container } from './styled.js';
import { jsxs, jsx } from 'react/jsx-runtime';
import { Typography } from '../../../foundation/Typography/styled.js';

function ListItemText(props) {
  var primary = props.primary,
    secondary = props.secondary,
    dense = props.dense;
  return /*#__PURE__*/jsxs(Container, {
    $dense: dense,
    children: [/*#__PURE__*/jsx(Typography, {
      $truncate: true,
      $appearance: "300",
      $fontSize: dense ? 'small' : 'medium',
      $lineHeight: dense ? 'neutralized' : 'default',
      children: primary
    }), secondary && /*#__PURE__*/jsx(Typography, {
      $truncate: true,
      $appearance: "100",
      $fontSize: dense ? 'tiny' : 'small',
      $lineHeight: dense ? 'neutralized' : 'default',
      children: secondary
    })]
  });
}

export { ListItemText };
